<template>
  <div>
    <div class="Header-Wrapper">
      <simple-header :label="$t('tasting.previous')" @click="goBack" />
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import userMixin from '@/mixins/user'
import SimpleHeader from '@/components/navigation/SimpleHeader'
import { PREV_TASTING_STEP } from '@/store/modules/tasting/types'

export default {
  name: 'TastingSkeleton',
  mixins: [userMixin],
  components: { SimpleHeader },
  data() {
    return { 
      prevRoute: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  computed: {
    comingFromListTasting() {
      return this.prevRoute && this.prevRoute.path === '/listTasting' ? true : false
    },
    commingFromFavoritewines() {
      return this.prevRoute && this.prevRoute.path === '/userAccount/favoriteWine' ? true : false
    }
  },
  methods: {
    goBack() {
      if (this.commingFromFavoritewines) {
        this.$router.push({ name: 'userAccountFavoriteWine' })
      } else if (this.comingFromListTasting) {
        this.$router.push({ name: 'listTasting' })
      } else {
        this.$store.dispatch(PREV_TASTING_STEP)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.Header-Wrapper {
  padding-top: 15px;
  padding-left: 10px;
}
</style>
